module.exports = __webpack_public_path__ + "img/pic_autograph@2x.1e830cfb.png";